export default [
   "Audax",
   "Caloi",
   "Oggi",
   "Groove",
   "Soul",
   "Sense",
   "Monark",
   "Sundow",
   "Cannondale",
   "Scott",
   "Specialized",
   "Trek",
   "GTS",
   "TSW",
   "Absolute",
   "Rino",
   "Houston",
   "South",
   "Everest",
   "GTA",
   "Storm",
   "Dropp",
   "Outras",
   "Khs",
   "Merida",
   "Bmc",
   "Gary Fisher",
   "Sundown",
   "Status",
   "Mormaii",
   "Oxer",
   "Kona",
   "Rava",
   "Skyrun",
   "Kode",
   "Black Orange",
   "GT",
   "Red Stone",
   "BTwin",
   "Ox Bike",
   "Rockrider",
   "Van Rysel",
   "Shoot",
   "Nathor",
   "Pinarello",
   "Pedalla",
   "Cube",
   "Wendy",
   "Foxxer",
   "KSW",
   "KRW",
   "First",
   "Focus",
   "Lotus",
   "High One",
   "Ecos",
   "Hunter",
   "Trust",
   "Elleven"
]
